import { render, staticRenderFns } from "./pax_form.vue?vue&type=template&id=c6c54f3e&scoped=true&"
import script from "./pax_form.vue?vue&type=script&lang=js&"
export * from "./pax_form.vue?vue&type=script&lang=js&"
import style0 from "./pax_form.vue?vue&type=style&index=0&id=c6c54f3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c54f3e",
  null
  
)

export default component.exports